export default __webpack_public_path__ + "static/media/babydev 1.e714a1c6.png";